import { useState } from 'react';

import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';

import { APPLICATION_HEADERS, API_URLS } from '../../models/headers';
import {
  calcCapacity,
  calcMonthTerms,
  formatDate,
  strToArray,
  reorderData,
} from '../../utils/utils';

const putShortlistedOptions = (updatedIds, mode, surveyData, selectedId, dispatch) => {
  const url = API_URLS.updateBubbleOptionURL;
  const reqObject = { list: [] };

  if (mode === 'ADD') {
    reqObject.list = updatedIds.map((optionId, index) => ({
      id: optionId,
      shortListed: true,
      shortlistedOrder: index + 1,
    }));
  }

  if (mode === 'REMOVE') {
    const updatedList = updatedIds.map((optionId, index) => ({
      id: optionId,
      shortListed: true,
      shortlistedOrder: index + 1,
    }));

    reqObject.list = [
      ...updatedList,
      {
        id: selectedId,
        shortListed: false,
        shortlistedOrder: 0,
      },
    ];
  }

  if (mode === 'RESET') {
    reqObject.list = updatedIds.map((id, index) => {
      return {
        id: id,
        shortListed: true,
        shortlistedOrder: index + 1,
      };
    });
  }

  return axios.put(url, reqObject, { headers: APPLICATION_HEADERS.dealHeaders }).catch((error) => {
    if (error) {
      console.log(error);
    } else {
      putShortlistedOptions(updatedIds, surveyData);
    }
  });
};
const useAddShortlistedoption = (option) => {
  const dispatch = useDispatch();
  const shortlistIds = useSelector((state) => state.shortlistRed.shortlistedIds);
  const surveyData = useSelector((state) => state.optRed.data);
  const [inProgress, setInProgress] = useState(false);
  const [err, setErr] = useState('');

  const putOption = async (func, mode, ids, reOrderShortList) => {
    setInProgress(true);
    const id = option?.id;
    let updatedIds;

    if (mode === 'ADD') {
      if (shortlistIds.includes(id)) {
        return;
      }
      updatedIds = [id, ...shortlistIds];
    }

    if (mode === 'REMOVE') {
      const existingItems = shortlistIds.slice();

      updatedIds = existingItems.filter((el) => el !== id);
    }

    if (mode === 'RESET') {
      updatedIds = ids;
    }

    try {
      const response = await putShortlistedOptions(updatedIds, mode, surveyData, id, dispatch);

      if (response && response.status === 200) {
        if (mode === 'RESET') {
          dispatch({
            type: 'SET_SHORTLIST_DATA',
            shortlistedOptions: reOrderShortList,
          });
        }

        if (mode === 'ADD') {
          dispatch({
            type: 'SELECT',
            option: {
              providerName: option.providerName,
              // id: option.ID,
              id: option.id,
              images: strToArray(option.images),
              addressObj: option.address,
              address:
                option.address && option.address.address
                  ? option.address.address
                  : option.addressBackup,
              capacity: calcCapacity(option),
              availDate: formatDate(option),
              amenities: strToArray(option.amenities),
              cost: calcMonthTerms(option),
              notes: option.notes,
              availableSpaceList: option.availableSpaceList,
              ratesToInclude: option.ratesToInclude,
              optionId: option.id,
              optionName: option.optionName,
              coordinates: option.coordinates,
              avails: option.availableSpaceList,
              queryData: option.queryData,
              queryResponse: option.queryResponse,
              commonQuestons: surveyData.commonQuestions,
              rateVariableTerm: option.rateVariableTerm,
              tourRequestedDate: option.tourRequestedDate,
              tourScheduledDate: option.tourScheduledDate,
              tourScheduledSlot: option.tourScheduledSlot,
              contactName: option.contactName,
              contactNumber: option.contactNumber,
              arrivalDetails: option.arrivalDetails,
              tourCompleted: option.tourCompleted,
              floorPlan: option.floorPlan,
              shortListed: true,
              shortlistedOrder: 1,
            },
          });
        }
        func();
        setInProgress(false);
      }
    } catch (err) {
      setErr('ERROR');
      setInProgress(false);
    }
  };

  return { putOption, inProgress };
};

export default useAddShortlistedoption;
